<template>
  <e-chart :options="chartOptions" autoresize />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/grid'

import i18n from '@/lib/i18n'

export default {
  components: {
    'e-chart': ECharts,
  },
  props: {
    observedData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: [
            i18n.tt('observation.precipitation'),
            i18n.tt('observation.soilTemperature') + '6cm',
            i18n.tt('observation.soilMoisture') + ' 1-3cm',
            i18n.tt('observation.soilMoisture') + ' 3-9cm',
          ],
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: [
          {
            type: 'value',
            name: i18n.tt('observation.soilMoisture') + ' (m³/m³)',
            position: 'left',
          },
          {
            type: 'value',
            name: i18n.tt('observation.soilTemperature') + ' (°C)',
            position: 'right',
            offset: 80,
          },
          {
            type: 'value',
            name: i18n.tt('observation.precipitation') + ' (mm)',
            position: 'right',
          },
        ],
        series: [
          {
            name: i18n.tt('observation.precipitation'),
            type: 'bar',
            yAxisIndex: 2,
            data: [],
          },
          {
            name: i18n.tt('observation.soilTemperature') + '6cm',
            type: 'line',
            yAxisIndex: 1,
            data: [],
          },
          {
            name: i18n.tt('observation.soilMoisture') + ' 1-3cm',
            type: 'line',
            yAxisIndex: 0,
            data: [],
          },
          {
            name: i18n.tt('observation.soilMoisture') + ' 3-9cm',
            type: 'line',
            yAxisIndex: 0,
            data: [],
          },
        ],
      },
    }
  },
  mounted() {
    this.processData(this.observedData)
  },
  methods: {
    processData(observedData) {
      this.chartOptions.xAxis.data = observedData.time
      this.chartOptions.series[0].data = observedData.precipitation
      this.chartOptions.series[1].data = observedData.soil_temperature_6cm
      this.chartOptions.series[2].data = observedData.soil_moisture_1_to_3cm
      this.chartOptions.series[3].data = observedData.soil_moisture_3_to_9cm
    },

    // FIXME
    // 現在未使用。redrawするタイミングが現在のデータ構造だと難しい。2024.01.24
    redraw() {
      if (this.observedData) {
        this.processData(this.observedData)
      }
    },
  },
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 30vh;
}
</style>
